export const language: any = {
  LabelCarts: "Keranjang",
  Material: "Bahan",
  nodata: "Tidak ada data di keranjang",
};
